import React from "react";
import { files } from "../configs";

const ProgressBar = ({ moveProgBar }) => {
  return (
    <div className="survey-prog">
      <img
        src={files + "/running_icon.svg"}
        alt="PROGRESS"
        className="run-icon"
        style={{ marginLeft: moveProgBar - 2 + "%" }}
      />
      <div className="prog-bar" />
      <div
        className="prog-bar prog-bar-fill"
        style={{ width: moveProgBar + "%" }}
      />
      <div className="prog-marker" style={{ left: moveProgBar + "%" }}>
        <div className="prog-marker-inner" />
      </div>
    </div>
  );
};

export default ProgressBar;
